export const TOMATO_AWARDS = {
    visit: 1, // 로그인해서 방문(하루 1회)
    comment: 10, // 댓글·대댓글
    post_market: 10, // 장터 글
    post_talk: 30, // 수다·정보 등 라운지 글
    referral: 100, // 회원 추천(피추천자가 가입을 마치면)
    hunt: 3, // 오늘의 토마토 찾기(하루 1회) — 방문과 비슷한 소액. 튜닝은 이 값만 바꾸면 된다.
};
export const TOMATO_REASON_LABELS = {
    visit: '오늘 첫 방문',
    comment: '댓글',
    post_market: '장터 글',
    post_talk: '라운지 글',
    referral: '친구 초대',
    hunt: '오늘의 토마토',
    harvest: '토마토 따기',
};
/** 활동명 옆 등에 붙일 표기. 예: 42🍅 */
export function formatTomato(n) {
    return `${n.toLocaleString('ko-KR')}🍅`;
}
//# sourceMappingURL=tomato.js.map